/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{color:#e87a59}@media (max-width:767px){[_nghost-%COMP%]{margin-bottom:30px}}"];
export { styles as styles };
